<template>
    <MainContentSearchable title="Listado de productos" id="productos" v-model="filters" :meta="loading ? {} : productos?.meta" @updated="debouncedGetProductos">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de productos</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.productos.categorias' }" class="btn btn-primary mr-2" id="categorias">
                    Categorías
                </router-link>
                <router-link :to="{ name: 'back.productos.crear' }" class="btn btn-primary" id="crear-producto">
                    Crear producto
                </router-link>
            </div>
        </template>

        <template v-slot:extra-options>
            <select class="custom-select w-auto mr-auto ml-3 mt-2" id="categorias" v-model="filters.category_id" @change="debouncedGetProductos()">
                <option value="">Categorias</option>
                <option v-for="categoria in categorias" :value="categoria.id" :key="categoria.id">
                    {{ categoria.name }}
                </option>
            </select>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="['table', { 'expanded': productos.data?.length <= 3 }]">
                    <b-table hover :items="productos.data" :fields="fields" responsive>
                        <template #cell(imagen)="{ item }">
                            <img :src="item.imagen" style="width: 100px;"/>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="productos.data?.length > 3 && index >= productos.data?.length - 3"
                                v-bind:options="[
                                    { to: { name: 'back.productos.editar', params: { product_id: item.id } }, label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                                ]"
                            />
                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar producto ' + item.name"
                                confirmButton="¿Está segur@ de borrar este producto?"
                                @close="() => closeModal()"
                                @confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                loading: false,
                productos: null,
                categorias: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    category_id: '',
                },
                fields: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "description", label: "Descripción", class: 'text-center' },
                    { key: "imagen", label: "Imagen", class: 'text-center' },
                    { key: "categoria.name", label: "Categoría", class: 'text-center' },
                    { key: "Opciones", label: "opciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getProductos();
            this.getCategorias();
            this.debouncedGetProductos = _.debounce(this.getProductos, 500)
        },
        methods: {
            getProductos() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.index'), params).then(res => {
                    this.productos = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            getCategorias() {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    to_select: true
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.index'), params).then(res => {
                    this.categorias = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrar(product_id) {
                this.loading = true;

                let params = {
                    teatro_id: this.teatro.id,
                    product_id: product_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getProductos();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>